import { Module } from 'vuex'

const scopeModule: Module<any, any> = {
  namespaced: true,

  state: () => ({
    enabledScopes: [],
  }),

  mutations: {
    setEnabledScopes(state, enabledScopes) {
      state.enabledScopes = enabledScopes
    },
  },
  actions: {
    setEnabledScopes({ commit }, enabledScopes) {
      commit('setEnabledScopes', enabledScopes)
    },
  },
  getters: {
    enabledScopes(state) {
      return state.enabledScopes
    },
  },
}

export default scopeModule
